<template>
    <div class="serie-main-info w-full pb-10">
        <div
            class="flex sr-container flex-col items-center lg:flex-row lg:items-start flex-wrap  w-full lg:w-11/12 mx-auto pt-12"
            :class="showLogo ? 'justify-between' : 'justify-end'"
        >
            <app-image
                v-if="showLogo"
                :url="serie.more.logo"
                :key="serie.more.logo"
                class="w-auto h-auto mb-6 lg:mr-4"
                :class="{ 'm-auto': $isMobile() }"
                :style="{
                    maxWidth: $isMobile() ? '75%' : '45%',
                    maxHeight: '250px'
                }"
            ></app-image>

            <div class="flex flex-col w-11/12 lg:w-1/2 bg-white-fog">
                <div
                    v-html="serie.more.sinopsis"
                    class="font-primary text-lg text-jusitfy mb-3"
                    :style="{ color: textAndIconsColor }"
                ></div>

                <div class="flex flex-col sm:flex-row items-center mb-3">
                    <div
                        v-if="serie.studio"
                        class="flex items-center justify-center sm:mr-10"
                    >
                        <svg-icon
                            icon="Studio-icon-01"
                            :fill="textAndIconsColor"
                            class="w-12 mr-2"
                            :key="serie.id"
                        >
                        </svg-icon>

                        <span
                            class="font-secondary text-lg"
                            :style="{ color: textAndIconsColor }"
                            >{{ serie.studio }}</span
                        >
                    </div>

                    <div
                        v-if="serie.age_range"
                        class="flex items-center justify-center"
                    >
                        <svg-icon
                            v-if="ageRangeIcon"
                            :icon="ageRangeIcon"
                            :fill="textAndIconsColor"
                            class="w-12 mr-2"
                            :key="serie.id"
                        >
                        </svg-icon>

                        <span
                            class="font-secondary text-lg"
                            :style="{ color: textAndIconsColor }"
                        >
                            {{ serie.age_range }} {{ $config("YEARS") }}
                        </span>
                    </div>
                </div>

                <div
                    class="flex flex-col sm:flex-row items-center justify-center"
                >
                    <btn
                        @click="playTrailer"
                        v-if="serie.trailer"
                        class="rounded-large bg-blue-lighter text-white px-6 sm:mr-6 mb-4 sm:mb-0"
                    >
                        <app-image
                            url="VerTrailer-icon-01.svg"
                            is-local
                            :try-webp="false"
                            alt="Ícono reproducir trailer"
                            class="w-8 mr-2"
                        ></app-image>
                        {{ $config("WATCH_TRAILER") }}
                    </btn>

                    <btn
                        class="rounded-large bg-orange text-white px-6"
                        v-on:click="playEpisodes()"
                    >
                        <app-image
                            url="play-icon.png"
                            is-local
                            :try-webp="false"
                            alt="Ícojo reproducir"
                            class="w-8 mr-2"
                        ></app-image>
                        {{ $config("WATCH_EPISODES") }}
                    </btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Btn from "./Btn";
import SvgIcon from "./SvgIcon";

export default {
    name: "serie-main-info",

    components: { Btn, SvgIcon },

    props: {
        serie: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapState(["authenticatedUser", "authenticatedUserAccess"]),
        ...mapGetters(["registerOrHomeRoute"]),

        showLogo() {
            return this.$isMobile() || !this.serie.img_tv;
        },

        ageRangeIcon() {
            if (this.serie.age_range === "0 - 1") {
                return "0-1years";
            }

            if (this.serie.age_range === "0 - 3") {
                return "0-3years";
            }

            if (this.serie.age_range === "4 - 7") {
                return "4-7years";
            }

            return null;
        },

        textAndIconsColor() {
            console.log(this.serie.more.color_descripcion);
            console.log(this.serie.more.color_descripcion_mobile);

            if (this.$isMobile())
                return this.serie.more.color_descripcion_mobile || "#FFFFFF";

            return "#575757";
        }
    },

    methods: {
        playTrailer() {
            let trailer = {
                id: 0,
                url: this.serie.trailer,
                title: `${this.serie.title} trailer`
            };

            let videos =
                this.authenticatedUser && this.authenticatedUserAccess == "full"
                    ? [trailer, ...this.serie.episodes]
                    : [trailer];

            this.$store.dispatch("OPEN_PLAYER", { videos });
        },

        playEpisodes() {
            if (!this.authenticatedUser) {
                this.$router.push({ name: "login" });
            } else if (this.authenticatedUserAccess != "full") {
                this.$router.push({ name: "register-payment" });
            } else {
                this.$store.dispatch("OPEN_PLAYER", {
                    videos: this.serie.episodes
                });
            }
        }
    }
};
</script>
<style scoped>
.desc-limited {
    height: 160px;
    overflow: auto;
}
.bg-white-fog {
    background: #ffffffdd;
    padding: 1em;
    border-radius: 0.5em;
}
</style>
